import { resolveSiteAndAddressDisplayInfo, type InstallationIdentityLike } from "@/lib/installationContext";

export function InstallationAddress({ installation, showMaps = true }: { installation: InstallationIdentityLike; showMaps?: boolean }) {
  const location = resolveSiteAndAddressDisplayInfo(installation);
  return (
    <span className="inline-flex min-w-0 max-w-full flex-col gap-1 break-words [overflow-wrap:anywhere]">
      <span>{location.address}</span>
      {location.provenance === "legacy" && (
        <span className="text-xs font-normal text-muted-foreground">Dirección legacy</span>
      )}
      {showMaps && location.mapsUrl && (
        <a href={location.mapsUrl} target="_blank" rel="noopener noreferrer"
          className="text-xs font-normal text-ods-navigation underline underline-offset-2"
          onClick={(event) => event.stopPropagation()}>
          Abrir en Maps
        </a>
      )}
    </span>
  );
}
